import SlotBasket from './SlotBasket'

export default SlotBasket
